var _style, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArLogo = function SvgArLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 47 54",
    style: {
      enableBackground: "new 0 0 47 54"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{fill:#898989;}\n\t")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -15,
    y: -12,
    width: 78,
    height: 78
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.9,40.6c-0.4,0-0.6-0.3-0.6-0.6V14c0-0.4,0.3-0.7,0.6-0.7c0.4,0,0.7,0.3,0.7,0.6c0,0,0,0,0,0.1v25.9 C46.5,40.3,46.2,40.6,45.9,40.6C45.9,40.6,45.9,40.6,45.9,40.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.1,40.6c-0.4,0-0.6-0.3-0.6-0.6c0-0.2,0.1-0.5,0.3-0.6l44.8-25.9c0.3-0.2,0.7-0.1,0.9,0.2 s0.1,0.7-0.2,0.9L1.4,40.5C1.3,40.5,1.2,40.6,1.1,40.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.9,14.7c-0.1,0-0.2,0-0.3-0.1L23.2,1.7c-0.3-0.2-0.4-0.6-0.2-0.9s0.6-0.4,0.9-0.2l22.4,12.9 c0.3,0.2,0.4,0.6,0.3,0.9C46.3,14.6,46.1,14.7,45.9,14.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.9,40.6c-0.1,0-0.2,0-0.3-0.1L0.8,14.6c-0.3-0.2-0.4-0.6-0.2-0.9c0.2-0.3,0.5-0.4,0.8-0.2l44.8,25.9 c0.3,0.2,0.4,0.6,0.2,0.9C46.3,40.4,46.1,40.6,45.9,40.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.1,14.7c-0.4,0-0.6-0.3-0.7-0.6c0-0.2,0.1-0.5,0.3-0.6L23.2,0.6c0.3-0.2,0.7-0.1,0.9,0.2s0.1,0.7-0.2,0.9 L1.4,14.6C1.3,14.7,1.2,14.7,1.1,14.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.5,53.4c-0.4,0-0.6-0.3-0.6-0.6V1.1c0-0.4,0.3-0.6,0.6-0.6c0.4,0,0.6,0.3,0.6,0.6l0,0v51.7 C24.2,53.2,23.9,53.4,23.5,53.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.1,40.6c-0.4,0-0.6-0.3-0.6-0.6c0,0,0,0,0,0V14c0-0.4,0.3-0.7,0.6-0.7c0.4,0,0.7,0.3,0.7,0.6 c0,0,0,0,0,0.1v25.9C1.8,40.3,1.5,40.6,1.1,40.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.5,53.5c-0.4,0-0.6-0.3-0.6-0.6c0-0.2,0.1-0.5,0.3-0.6l22.4-12.9c0.3-0.2,0.7-0.1,0.9,0.2 c0.2,0.3,0.1,0.7-0.2,0.9l-22.4,13C23.7,53.5,23.6,53.5,23.5,53.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.5,53.5c-0.1,0-0.2,0-0.3-0.1l-22.4-13c-0.3-0.2-0.4-0.6-0.2-0.9c0.2-0.3,0.6-0.4,0.9-0.2l22.4,13 c0.3,0.2,0.4,0.6,0.2,0.9C24,53.4,23.7,53.5,23.5,53.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30,6c-0.2,0-0.4-0.1-0.6-0.2l-6-3.4l-6,3.4C17,6.2,16.3,6,16,5.4c-0.3-0.5-0.1-1.2,0.4-1.5L23,0.2 c0.3-0.2,0.8-0.2,1.1,0l6.5,3.8c0.5,0.3,0.7,1,0.4,1.5C30.8,5.8,30.4,6,30,6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.5,35.6c-0.6,0-1.1-0.5-1.1-1.1c0,0,0,0,0,0V27c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1c0,0,0,0,0,0v7.5 C24.6,35.1,24.1,35.6,23.5,35.6C23.5,35.6,23.5,35.6,23.5,35.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1.1,22.7c-0.6,0-1.1-0.5-1.1-1.1c0,0,0,0,0,0V14c0-0.6,0.5-1.1,1.1-1.2c0.6,0,1.1,0.5,1.2,1.1 c0,0,0,0,0,0.1v7.5C2.2,22.2,1.7,22.7,1.1,22.7C1.1,22.7,1.1,22.7,1.1,22.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.9,22.7c-0.6,0-1.1-0.5-1.1-1.1c0,0,0,0,0,0V14c0-0.6,0.5-1.1,1.1-1.2c0.6,0,1.1,0.5,1.2,1.1 c0,0,0,0,0,0.1v7.5C47,22.2,46.5,22.7,45.9,22.7L45.9,22.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.9,41c-0.6,0-1.1-0.5-1.1-1.1c0,0,0,0,0,0l0-7.5c0-0.6,0.5-1.1,1.1-1.1h0l0,0c0.6,0,1.1,0.5,1.1,1.1 c0,0,0,0,0,0l0,7.5C47,40.5,46.5,41,45.9,41C45.9,41,45.9,41,45.9,41L45.9,41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1.1,41C0.5,41,0,40.5,0,39.9c0,0,0,0,0,0v-7.5c0-0.6,0.5-1.1,1.1-1.2s1.1,0.5,1.2,1.1c0,0,0,0,0,0.1v7.5 C2.2,40.5,1.7,41,1.1,41C1.1,41,1.1,41,1.1,41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.5,10.5c-0.6,0-1.1-0.5-1.1-1.1c0,0,0,0,0,0V1.1c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1 c0,0,0,0,0,0v8.2C24.6,10,24.1,10.5,23.5,10.5C23.5,10.5,23.5,10.5,23.5,10.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.5,54c-0.6,0-1.1-0.5-1.1-1.1c0,0,0,0,0,0v-7.5c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1c0,0,0,0,0,0v7.5 C24.6,53.5,24.1,54,23.5,54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.5,54c-0.2,0-0.4-0.1-0.6-0.2l-6.6-3.8c-0.5-0.3-0.7-1-0.4-1.5c0.3-0.5,1-0.7,1.5-0.4l0,0l6,3.5l5.9-3.4 c0.5-0.3,1.2-0.1,1.5,0.4c0.3,0.5,0.1,1.2-0.4,1.5l-6.5,3.8C23.9,53.9,23.7,54,23.5,54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.5,28.1c-0.2,0-0.4-0.1-0.6-0.2l-6.5-3.8c-0.5-0.3-0.7-1-0.4-1.5c0.3-0.5,1-0.7,1.5-0.4l6,3.4l6-3.4 c0.5-0.3,1.2-0.1,1.5,0.4c0.3,0.5,0.1,1.2-0.4,1.5L24.1,28C23.9,28.1,23.7,28.1,23.5,28.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.4,18.9c-0.6,0-1.1-0.5-1.1-1.1c0-0.4,0.2-0.8,0.6-1l6.5-3.8c0.5-0.3,1.2-0.1,1.5,0.4 c0.3,0.5,0.1,1.2-0.4,1.5l-6.5,3.8C39.7,18.9,39.6,18.9,39.4,18.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.9,15.2c-0.2,0-0.4-0.1-0.6-0.2l-6.5-3.8c-0.5-0.3-0.7-1-0.4-1.5s1-0.7,1.5-0.4c0,0,0,0,0,0l6.5,3.8 c0.5,0.3,0.7,1,0.4,1.5C46.7,15,46.3,15.2,45.9,15.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.6,18.9c-0.2,0-0.4-0.1-0.6-0.2L0.6,15c-0.5-0.3-0.7-1-0.4-1.5s1-0.7,1.5-0.4l6.5,3.8 c0.5,0.3,0.7,1,0.4,1.5C8.4,18.7,8.1,18.9,7.6,18.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1.1,15.2C0.5,15.2,0,14.7,0,14c0-0.4,0.2-0.8,0.6-1l6.5-3.8C7.6,9,8.3,9.2,8.6,9.8 c0.3,0.5,0.1,1.2-0.4,1.5L1.7,15C1.5,15.1,1.3,15.2,1.1,15.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.3,44.8c-0.6,0-1.1-0.5-1.1-1.1c0-0.4,0.2-0.8,0.6-1l6.5-3.8c0.5-0.3,1.2-0.2,1.5,0.4s0.2,1.2-0.4,1.5 c0,0,0,0-0.1,0l-6.5,3.8C39.7,44.8,39.5,44.8,39.3,44.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.9,41c-0.2,0-0.4-0.1-0.6-0.2l-6.5-3.8c-0.5-0.3-0.7-1-0.4-1.5c0.3-0.5,1-0.7,1.5-0.4l6.5,3.8 c0.5,0.3,0.7,1,0.4,1.5C46.7,40.8,46.3,41.1,45.9,41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.6,44.8c-0.2,0-0.4-0.1-0.6-0.2l-6.5-3.8c-0.5-0.3-0.7-1-0.4-1.5c0.3-0.5,1-0.7,1.5-0.4l6.5,3.8 c0.5,0.3,0.7,1,0.4,1.5C8.4,44.6,8.1,44.8,7.6,44.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1.1,41c-0.6,0-1.1-0.5-1.1-1.1c0-0.4,0.2-0.8,0.6-1l6.5-3.8c0.5-0.3,1.2-0.1,1.5,0.4s0.1,1.2-0.4,1.5l0,0 l-6.5,3.8C1.5,41,1.3,41,1.1,41"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ar_logo.ebf60d5a.svg";
export { ForwardRef as ReactComponent };